import type { AssessmentResultCount } from '@risksmart-app/trpc/src/types';
import type { GetAssessmentResultCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

export const useGetAssessmentResultCount = createQueryHook<
  Record<string, never>,
  AssessmentResultCount,
  GetAssessmentResultCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.assessment.assessmentResultCount.queryOptions(),
  // Map each per-table count back onto its GraphQL aggregate root. ConnectedCount
  // sums the three; the factory surfaces undefined while loading, so genuine
  // zeros are preserved (no `?? 0` masking).
  mapTrpcDataToGraphQL: (data) => ({
    risk_assessment_result_aggregate: {
      aggregate: { count: data.risk_assessment_result },
    },
    document_assessment_result_aggregate: {
      aggregate: { count: data.document_assessment_result },
    },
    obligation_assessment_result_aggregate: {
      aggregate: { count: data.obligation_assessment_result },
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetAssessmentResultCountDocument,
});
